eshopApp.controller('ContactFormsController', ['$scope', '$http', '$cookies', '$rootScope', 'quickModal', 'alertMessage', function($scope, $http, $cookies, $rootScope, quickModal, alertMessage){

	// Helpers
	$scope.helper = CustomNameSpace.helpers;

	$rootScope.m_FullCart = true;
	$scope.cart_empty = null;
	$scope.spinner = true;

	$scope.fetch_counter = 0;
	$scope.old_products = null;

	$scope.requestOfferMessage = "";
	$scope.auth_user_email = angular.element(document).find('#auth_user_email').val();
	$scope.auth_user_name = angular.element(document).find('#auth_user_name').val();

	// Get cart
	$scope.fetchCart = function() {

		$http.get('/a/get_cart').success(function(response) {

			if(response.products !== false) {

				$scope.cart = response;
				$scope.cart_empty = false;

				// Reload page if products change
				if ($scope.old_products !== null && $scope.old_products !== JSON.stringify(response.products)) {
					//location.reload();
				}
				$scope.old_products = JSON.stringify(response.products);

				// If customer data has been set, set self and ShippingMethodSelector to visible
				/*if (response.has_customer && response.has_shippingaddress && response.has_billingaddress) {
					$rootScope.m_FullCart = true;
					if ($scope.fetch_counter < 1) {
						$rootScope.m_ShippingMethodSelector = true;
					}
				}*/

			} else {
				$scope.cart_empty = true;
			}
		}).finally(function(){
			$scope.spinner = false;
			$scope.fetch_counter += 1;
			$scope.updateHiddenForm();
		});

	}

	// Listen for changes to cookie and update cart (fetch data)
	$scope.$watch(function(){ return $cookies.get('cart_updated') }, function(){
		$scope.fetchCart();
	});

	$scope.updateHiddenForm = function() {
		// Update form fields
		angular.element(document).find('input[name="email"]').val($scope.auth_user_email);
		angular.element(document).find('input[name="name"]').val($scope.auth_user_name);
		angular.element(document).find('input[name="subject"]').val('Tarjouspyyntö');
		if($scope.cart.products.data.length > 0) {
			// String presentation of cart contents
			$scope.requestOfferMessage = "\n\nOstoskorissa olevat tuotteet: \n";
			angular.forEach($scope.cart.products.data, function(v, k) {
				var line = v.sku + ' ' + v.name + ' ' + v.quantity + 'kpl \n';
				$scope.requestOfferMessage += line;
			});
		}
	};

}]);
